var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceiro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M0 10C0 4.47717285 4.47715378 0 10 0s10 4.47717285 10 10-4.47715378 10-10 10S0 15.52282715 0 10zm2 0c0 4.41827393 3.58172226 8 8 8 4.41576385-.00604248 7.99394226-3.58422852 8-8 0-4.41827393-3.58172226-8-8-8-4.41827774 0-8 3.58172607-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M10.31 9.14c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.0325559-1.45076905-1.06716382-2.68481946-2.49-2.97V3H8.9v1.69c-1.47242042.14427221-2.62371839 1.3336646-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H6.04c.12028113 1.54661636 1.31902173 2.79146237 2.86 2.97V17h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceiro);
export default __webpack_public_path__ + "static/media/financeiro.ba88443b89cbcc760c601fc69dc67253.svg";
export { ForwardRef as ReactComponent };